const config = {
  appStartMonth: 5,
  appStartYear: 2024,
  appEndMonth: 6,
  appEndYear: 2029
}

export default config